import React, { useState, useEffect } from 'react';
import { translate } from 'react-switch-lang';
import { ListingDatatable } from '../../_fragments';
import Form from './Form';
import { zoneSchema as schema } from '../../_validationSchema';
import { zoneAction as actions } from '../../_action/zone.action';
import { zone_model as model } from '../../_model';
import { zoneConstants as constants } from '../../_constants';
import { locationConstants as location_constants } from '../../_constants';

import { useSelector } from 'react-redux';

const Zone = (props) => {
  const { t } = props;

  const header = { name: 'Zone', icon: 'cubes' };
  const reducer = useSelector((state) => state.zoneOperation);
  const [item, setItem] = React.useState({});

  const filenameXML = 'Zone';
  const menuCode = 'M_ZONE';
  const columns = [
    { title: t('code'), field: 'Code' },
    { title: t('description'), field: 'Zone' },
    { title: t('location'), field: 'Location' },
  ];
  let useService = () => {
    return [schema, actions, model, constants, location_constants];
  };
  const [open, setOpen] = useState(false);
  const [selectedCode, setSelected] = useState('');
  const [type, setFormType] = useState('');
  const [keyTrigger, setTrigger] = useState(false);
  useEffect(() => {
    if (open === false) {
      setFormType('');
      setTrigger(!keyTrigger);
    }
  }, [open]);
  useEffect(() => {
    if (reducer.getSuccess) {
      setItem(reducer.data.data.info);
    }
  }, [reducer]);

  return (
    <>
      <Form
        type={type}
        header={header}
        code={selectedCode}
        open={open}
        setClose={() => setOpen(false)}
        useService={useService}
        reducer={reducer}
        item={item}
      />
      <ListingDatatable
        key={keyTrigger}
        header={header}
        columns={columns}
        filenameXML={filenameXML}
        setSelected={setSelected}
        setFormOpen={setOpen}
        setFormType={setFormType}
        menuCode={menuCode}
      />
    </>
  );
};

export default translate(Zone);
